import { ReactNode } from 'react';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import { Box, CircularProgress, Tooltip } from '@mui/material';

import { Text } from '~/components/ui/text';

import { useStyles } from './analyticsCard.styles';

type AnalyticsCardProps = {
  text: string;
  value: string | number;
  icon: ReactNode;
  tooltip?: string;
  isLoading: boolean;
};

export function AnalyticsCard({ text, value, icon, tooltip, isLoading }: AnalyticsCardProps) {
  const styles = useStyles();
  return (
    <Box sx={styles.cardConatiner}>
      <Box sx={styles.cardTextConatiner}>
        {icon}
        <Text variant="t16Medium">
          {text}
          {tooltip && (
            <Tooltip
              title={tooltip}
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: '#313031',
                    color: 'white',
                    fontSize: '12px',
                    fontWeight: '400',
                    lineHeight: '15px',
                    maxWidth: '400px',
                    padding: '8px 16px',
                  },
                },
              }}
            >
              <HelpRoundedIcon sx={styles.tooltipIcon} />
            </Tooltip>
          )}
        </Text>
      </Box>
      {isLoading ? <CircularProgress size={25} /> : <Text variant="h1.7">{value}</Text>}
    </Box>
  );
}
